import React from 'react';
import PropTypes from 'prop-types';

import PureComponent from '../pure';
import sAction from 'sAction';
import Button from '../formElements/Button';
import Input from '../formElements/InputText';
import Select from '../formElements/Select';
import ViewSelect from './ViewSelect';
// import {InputAdornment} from '@mui/material';
import MicrosoftButton from '../formElements/MicrosoftButton';
// import {browserSupportsWebAuthn} from '@simplewebauthn/browser';

export default class LoginForm extends PureComponent {
    constructor() {
        super();
        this.state = {
            name: true,
            pass: true,
            language: sAction.getLanguage(),
            showPassword: false,
            preferredLoginSSO: !!sAction.getStorage('preferredLoginSSO'),
        };
        this.name = React.createRef();
        this.pass = React.createRef();
        this.isEnforcedSSO = sAction.dataGet('conf/singleSignOn/isEnforcedSSO') || false;
        this.microsoftSSOEnabled = sAction.dataGet('conf/singleSignOn/microsoft/enabled') || false;

        // const configData = sAction.dataGet('conf/configData');
        // const webauthnSettings = sAction.param?.webauthnSettings ||
        //     (configData?.get ? configData.get('webauthnSettings') : null);
        // const passkeyEnabled = webauthnSettings?.get ?
        //     webauthnSettings.get('enable') === true :
        //     webauthnSettings?.enable === true;
        // const passkeySupported = this.passkeyEnableByCoripo && browserSupportsWebAuthn();
        const passkeyEnableByCoripo = sAction.dataGet('conf/passkeyEnableByCoripo') ?? false;
        this.passkeySupported = passkeyEnableByCoripo && false; // browserSupportsWebAuthn();
    }

    /**
     * submit login form
     */
    submit() {
        const name = this.name.current.value;
        const pass = this.pass.current.value;
        const language = this.state.language;
        let nameState = true;
        if (name === '' || name == null) {
            nameState = false;
        }
        let passState = true;
        if (pass === '' || pass == null) {
            passState = false;
        }

        if (passState && nameState) {
            sAction.logIn(name, pass, language, this.props.switchCallback);
            this.setState({name: true, pass: true});
        } else {
            this.setState({name: nameState, pass: passState});
        }
    }

    /**
     * submit on enter
     * @param {KeyboardEvent} e
     */
    onKeyDown(e) {
        if (e.keyCode === 13) {
            this.submit();
        }
    }

    /**
     * handle language select
     * @param {string} lang language code
     */
    setlanguage(lang) {
        sAction.rest.setCookie('language', lang);
        window.location.reload();
    }

    microsoftLogin = () => {
        sAction.usrMsgraphSignIn('_self', true);
    };

    passkeyLogin = () => {
        const name = this.name.current?.value?.trim();
        const language = this.state.language;
        sAction.passkeyLogin(name, language, this.props.switchCallback);
    };

    render() {
        const options = [];
        try {
            sAction.getLanguages().forEach((languageCode) => {
                options.push({value: languageCode, label: sAction.translateEnum('languageList', languageCode)});
            });
        } catch {
            options.push({
                value: 'cs_CZ',
                label: sAction.translate('LBL_LOGIN_LANGUAGE_CZECH'),
            });
            options.push({
                value: 'en_us',
                label: sAction.translate('LBL_LOGIN_LANGUAGE_ENGLISH'),
            });
            options.push({
                value: 'sk_SK',
                label: sAction.translate('LBL_LOGIN_LANGUAGE_SLOVAK'),
            });
        }

        const logoUrl = this.props.logo ? sAction.param.files + 'image/' + this.props.logo : sAction.param.companyLogo;

        const preferredLoginSSO = this.state.preferredLoginSSO;

        return (
            <div className="loginTable loginFormGrid" onKeyDown={(e) => this.onKeyDown(e)}>
                <div className="loginRow loginRowLogo">
                    <div className="login PageLogoContainer">
                        <img className='loginLogo' src={logoUrl} style={{maxWidth: '180px'}} />
                    </div>
                </div>
                {options.length > 1 && (
                    <div className="loginRow">
                        <Select
                            value={this.state.language}
                            containerClassName={'withBorder'}
                            onChange={(e) => this.setlanguage(e.target.value)}
                            label={sAction.translate('LBL_LOGIN_LANGUAGE')}
                            options={options}
                            variant="outlined"
                            id='language'
                        />
                    </div>
                )}

                {!preferredLoginSSO && (
                    <div className="loginRow">
                        <Input
                            autoFocus={true}
                            error={!this.state.name}
                            myRef={this.name}
                            containerClassName={'loginInput'}
                            label={sAction.translate('LBL_LOGIN_NAME')}
                            variant="outlined"
                            noDetail={true}
                            outlined={true}
                            id='username'
                            sx={{
                                'height': '40px',
                                '& input:-webkit-autofill': {
                                    boxShadow: '0 0 0px 1000px white inset',
                                },
                                '& .MuiOutlinedInput-input': {
                                    paddingTop: '12px',
                                    paddingBottom: '12px',
                                },
                            }}
                            // startAdornment={
                            //     <InputAdornment position="start">
                            //         <span className="iconfa-loginUser" />
                            //     </InputAdornment>
                            // }
                        />
                    </div>
                )}
                {!preferredLoginSSO && (
                    <div className="loginRow loginPassword__wrapper">
                        <Input
                            type={this.state.showPassword ? 'text' : 'password'}
                            error={!this.state.pass}
                            myRef={this.pass}
                            containerClassName={'loginInput'}
                            label={sAction.translate('LBL_LOGIN_PASSWORD')}
                            variant="outlined"
                            noDetail={true}
                            outlined={true}
                            id='password'
                            sx={{
                                'height': '40px',
                                '& .MuiOutlinedInput-input': {
                                    paddingTop: '12px',
                                    paddingBottom: '12px',
                                },
                            }}
                            // startAdornment={
                            //     <InputAdornment position="start">
                            //         <span className="iconfa-loginPassword" />
                            //     </InputAdornment>
                            // }
                            // endAdornment={
                            //     <InputAdornment position="end">
                            //         <span
                            //             className={`showPasswordIcon icon-${this.state.showPassword ? 'f0d9' : 'eye'}`}
                            //             onClick={() => this.setState({showPassword: !this.state.showPassword})}
                            //         />
                            //     </InputAdornment>
                            // }
                        />
                    </div>
                )}
                <div className={`loginRow loginButtons ${preferredLoginSSO ? 'preferredLoginSSO' : ''}`}>
                    {this.microsoftSSOEnabled !== true ? null : (
                        <div className={'singleSignOn'}>
                            <MicrosoftButton
                                onClick={this.microsoftLogin}
                                label={preferredLoginSSO ? sAction.translate('LBL_SIGN_IN_WITH_MICROSOFT') : null}
                            />
                        </div>
                    )}
                    <div className="loginButtonContainer">
                        <Button id='loginButton' className="loginButton" onClick={() => {
                            if (!preferredLoginSSO) {
                                this.submit();
                            } else {
                                this.setState({preferredLoginSSO: false});
                            }
                        }}>
                            <span className="iconfa-loginButton"></span>
                            {!preferredLoginSSO ? sAction.translate('LBL_LOGIN', 'default') : null}
                        </Button>
                    </div>
                </div>

                <div className="loginRow loginLinks">
                    {this.passkeySupported && (
                        <div className="loginButtonContainer passkeyLoginContainer">
                            <a
                                id='passkeyLoginButton'
                                className='passkeyLoginLink'
                                onClick={() => this.passkeyLogin()}
                            >
                                <span className="iconfa-passkeyLogin"></span>
                                {sAction.translate('LBL_PASSKEY_LOGIN')}
                            </a>
                        </div>
                    )}
                    <div className="loginButtonContainer">
                        {!this.isEnforcedSSO ? (
                            <a
                                id='forgottenPassword'
                                className='forgottenPassword'
                                onClick={() => this.props.switchCallback('resetPassword', {prefilledUsername: this?.name?.current?.value})}
                            >
                                <span className="iconfas-forgottenPassword"></span>
                                {sAction.translate('LBL_FORGOTTEN_PASSWORD')}
                            </a>
                        ) : (<span/>)}
                    </div>
                </div>
                {Object.prototype.hasOwnProperty.call(sAction.param, 'views') && Object.keys(sAction.param.views).length > 1 &&
                    <div className="loginRow deviceSelect acmMaterial">
                        <ViewSelect views={sAction.param.views}/>
                    </div>
                }
            </div>
        );
    }
}

LoginForm.propTypes = {
    logo: PropTypes.string,
    redirect: PropTypes.string,
    switchCallback: PropTypes.func.isRequired,
};
